import { NextPage } from 'next';
import Head from 'next/head';
import { useTranslation } from 'next-i18next';

import AboutPageRoot from 'src/about/components/Root';
import ReviewAndAppLinks from 'src/common/components/ReviewAndAppLinks';
import SubFooter from 'src/common/components/SubFooter';
import FooterLinks from 'src/common/components/FooterLinks';
import Footer from 'src/common/components/Footer';

import serverGetUser from 'src/common/utils/serverGetUser';
import handleApiErrors from 'src/common/utils/handleApiErrors';
import withCommonMiddleware from 'src/common/utils/withCommonMiddleware';
import DescriptionMetaTag from 'src/common/components/MetaTags/DescriptionMetaTag';
import Header from 'src/common/components/Header';
import Layout from 'src/common/components/Layout';
import SearchInputProvider from 'src/common/components/Search/SearchInputProvider';
import { loadTranslations } from 'src/common/utils/serverSidePropsHelpers';

type AboutPageProps = {};

const AboutPage: NextPage<AboutPageProps> = () => {
  const [t] = useTranslation('about-page');

  return (
    <>
      <Head>
        <title>
          {t('title')}
        </title>
      </Head>
      <DescriptionMetaTag
        content={t('meta-description')}
      />

      <Layout overscrollColor="ivory">
        <SearchInputProvider>
          <Header
            variant="ivory"
            withSearch
            showBottomBorderOnScroll
          />
        </SearchInputProvider>
        <AboutPageRoot />
        <Footer>
          <FooterLinks />
          <ReviewAndAppLinks />
          <SubFooter />
        </Footer>
      </Layout>
    </>
  );
};

export const getServerSideProps = handleApiErrors(
  withCommonMiddleware<AboutPageProps>(
    async (context) => ({
      props: {
        user: await serverGetUser(context),
        ...await loadTranslations(
          context.locale,
          [
            'common',
            'about-page',
            'navbar',
            'destination-navigation',
            'footer',
            'search-and-filters',
            'boat-categories',
            'pitch-page-browse-boats',
          ],
        ),
      },
    }),
  ),
);

export default AboutPage;
